module.exports = __webpack_public_path__ + "img/q1_2022.c2f2fdd0.jpg";